var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { "flex-grow": "1", background: "#F0F3F8" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "400px",
                height: "80px",
                background: "white"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    "margin-right": "10px",
                    "margin-top": "10px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.showBranchSelectDialog }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SystemMaintenance.SetExclusionOffices"))
                      )
                    ]
                  ),
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.branchSelectDialog.showExclusionOfficeIds,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.branchSelectDialog,
                          "showExclusionOfficeIds",
                          $$v
                        )
                      },
                      expression: "branchSelectDialog.showExclusionOfficeIds"
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("branch-select-dialog", {
        attrs: {
          visible: _vm.branchSelectDialog.visible,
          "office-list": _vm.branchSelectDialog.officeList,
          value: _vm.branchSelectDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.branchSelectDialog, "visible", $event)
          },
          callback: _vm.branchSelectDialog.callback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }